export const ARAR = {
    page: 'auto-return-and-resend-page',
    breadcrumbSection: 'auto-return-and-resend-page__breadcrumb-section',
    mainTabsSection: 'auto-return-and-resend-page__main-tabs-section',
    loadingSection: 'auto-return-and-resend-page__loading-section',
    searchSection: 'auto-return-and-resend-page__search-section',
    summarySection: 'auto-return-and-resend-page__summary-section',
    panelSection: 'auto-return-and-resend-page__panel-section',
    reportsSection: 'auto-return-and-resend-page__reports-section',
    reportDrawer: 'auto-return-and-resend-page__report-drawer',
    searchInput: 'auto-return-and-resend-page-input--shipping-numbers',
    searchActions: 'auto-return-and-resend-page__search-actions',
    summaryCard: 'auto-return-and-resend-page__summary-card',
    panelHeader: 'auto-return-and-resend-page__panel-header',
    panelGrid: 'auto-return-and-resend-page__panel-grid',
} as const;
